// extracted by mini-css-extract-plugin
export default {"headContainer":"eed5ec35048d","mainMessage":"ed6d9d9d79e7","productContainer":"e4d3414b446f","purchaseNow":"f466c5e11587"};